// Public sign-in/sign-up entry points (header buttons, landing CTAs, /pricing).
// Off during the phased service shutdown: customers no longer see a way in, but
// /sign-in, /app/callback and /signup/* stay routed so ops can still sign in by URL.
// Flip to true to restore every public entry point.
export const PUBLIC_SIGN_IN_ENABLED = false;
